import { createRoot } from 'react-dom/client';
import { Pano, type PanoData } from '../../components/Pano';

document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('pano-view-root');
    if (root) {
        // Get pano data from the root element's data attributes
        const panoDataStr = root.getAttribute('data-pano');
        const mode =
            (root.getAttribute('data-mode') as 'view' | 'edit') || 'view';

        let panoData: PanoData | undefined;
        if (panoDataStr) {
            try {
                panoData = JSON.parse(panoDataStr);
            } catch (error) {
                console.error('Failed to parse pano data:', error);
            }
        }

        createRoot(root).render(<Pano mode={mode} data={panoData} />);
    }
});
